// updated at: 2020-07-08T11:56:55.775Z

/* eslint-disable */
var data = require('./data');

var ContractNames = {
  Account: 'Account',
  AccountExternalDeposit: 'AccountExternalDeposit',
  AccountRegistry: 'AccountRegistry',
  AccountFriendRecoveryExtension: 'AccountFriendRecoveryExtension',
  ERC20Token: 'ERC20Token'
};

function getContractAddress(contractName) {
  var networkId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var result;

  if (data[contractName]) {
    result = data[contractName].addresses["".concat(networkId)];
  }

  return result || null;
}

function getContractAbiDefinition(contractName) {
  var result;

  if (data[contractName]) {
    result = data[contractName].abi;
  }

  return result || null;
}

function getContractByteCodeHash(contractName) {
  var result;

  if (data[contractName]) {
    result = data[contractName].byteCodeHash;
  }

  return result || null;
}

module.exports = {
  ContractNames: ContractNames,
  getContractAddress: getContractAddress,
  getContractAbiDefinition: getContractAbiDefinition,
  getContractByteCodeHash: getContractByteCodeHash
};